module.exports = __webpack_public_path__ + "img/proctor-require-4.a28d454e.png";